import './base_integration.js.coffee';# Added by Script 
Namespace 'Customer.Ticket.Integration'

class Customer.Ticket.Integration.Patagonia extends Customer.Ticket.Integration.BaseIntegration

  _identifier: ->
    'patagonia'

  _onErrorAlert: (response) ->
    swal.close()
    @trigger('ticket:export:error', response)

  _onRequestErrorAlert: (response) ->
    swal.close()
    @trigger('ticket:export:error', response)
